<template>
  <div
    :class="[
      'collapsible-panel',
      {
        'collapsible-panel--opened': opened,
        'collapsible-panel--open-to-top': openToTop,
      },
    ]"
    tabindex="-1"
  >
    <div
      class="cp-header"
      role="button"
      tabindex="0"
      @click="panelToggle"
      @keydown.enter="panelToggle"
      @keydown.space.prevent="panelToggle"
    >
      <slot name="header" />

      <fn-icon
        class="cp-header-icon"
        :icon="`arrow-${openToTop ? 'up' : 'down'}`"
        size="xs"
        role="presentation"
      />
    </div>
    <div
      v-show="opened"
      class="cp-content"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    openToTop: {
      type: Boolean,
    },
    defaultOpened: {
      type: Boolean,
    },
  },
  data: () => ({
    opened: false,
  }),
  mounted() {
    this.opened = this.defaultOpened;
  },
  methods: {
    panelToggle() {
      this.opened = !this.opened;
    },
  },
};
</script>

<style lang="scss" scoped>
.collapsible-panel {
  display: flex;
  flex-direction: column;
  width: 100%;

  &.collapsible-panel--opened {
    height: auto;
    max-height: 100%;

    .cp-header .cp-header-icon {
      transform: rotate(180deg);
    }
  }

  &.collapsible-panel--open-to-top .cp-header {
    order: 1;
  }

  .cp-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: math.div($space, 2) $pad;
    background-color: $color-brand-fnmz-green;
    color: $color-general-text-inverse-default;
    cursor: pointer;

    .cp-header-icon {
      transition: 0.2s all;
    }
  }

  .cp-content {
    max-height: calc(100% - 45px);
    overflow-y: auto;
    background-color: $color-general-background-neutral-default;
  }
}
</style>
